import React from 'react';
import PageHeader from '../components/PageHeader';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Industries = () => {
  const industries = [
    { title: 'Manufacturing', desc: 'Managing complex facility risks, chemical handling, and multi-shift workforce training.' },
    { title: 'Energy & Utilities', desc: 'Compliance with NERC-CIP, high-voltage safety, and specialized emergency response.' },
    { title: 'Oil & Gas', desc: 'Process safety management, hazmat response, and multi-agency coordination.' },
    { title: 'Nuclear Facilities', desc: 'Strict regulatory compliance, graded exercises, and specialized EOC operations.' },
    { title: 'Government Agencies (Federal, State, Tribal, and Local)', desc: 'FEMA/HSEEP-aligned exercises, THIRA support, and interagency planning.' },
    { title: 'Fire & Emergency Services', desc: 'ProBoard certification, leadership development, and technical rescue.' },
    { title: 'Critical Infrastructure', desc: 'Continuity of operations and physical/cyber threat preparedness.' },
    { title: 'Aviation & Airports', desc: 'ARFF training, mass casualty planning, and FAA compliance.' },
    { title: 'Transportation', desc: 'Hazardous materials transit, route risk assessments, and incident response.' },
    { title: 'Industrial and Residential Construction', desc: 'Site safety plans, contractor training and management systems, and transition to operations.' },
    { title: 'Small & Mid-Sized Businesses', desc: 'Practical EPA/OSHA compliance for growing companies managing hazardous materials.' },
    { title: 'Nonprofit Organizations', desc: 'Strategic planning, leadership academies, executive coaching, and organizational development.' }
  ];

  return (
    <div className="w-full bg-brand-light min-h-screen">
      <PageHeader 
        title="Industries We Serve" 
        description="Tailored emergency management and training solutions for complex operational environments." 
      />

      <section className="py-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((ind, i) => (
            <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200 hover:shadow-md hover:border-brand-green transition-all group">
              <div className="w-12 h-12 bg-brand-light text-brand-navy rounded-xl flex items-center justify-center mb-6 group-hover:bg-brand-navy group-hover:text-white transition-colors">
                <SafeIcon icon={FiIcons.FiBriefcase} className="text-xl" />
              </div>
              <h3 className="text-xl font-bold text-brand-navy mb-3">{ind.title}</h3>
              <p className="text-slate-600 font-medium leading-relaxed text-sm">{ind.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Industries;